<template>
  <div class="datav-map" :style="{ width:`calc( 100vw - ${isCollapse ? '60' : '160'}px` }">
    <datav-map-main ref="mainMap" class="main" @equip-click="handleEquipClick" />

    <div class="top flex-center column">
      <div class="font-2x text-bold letter-spacing">设备态势实时感知</div>
      <div class="mt-xs font-sm text-muted">Data from <a href="https://www.frippler.com" target="_blank">Frippler</a></div>
    </div>

    <div class="left">
      <div class="panel" style="position: absolute;top: 0px;height: 360px;">
        <div class="title">设备概览</div>
        <div class="body">
          <datav-map-equip-stats ref="equipStats" @equip-total-change="handleEquipTotalChange" />
        </div>
      </div>

      <div class="panel" style="position: absolute;top: 380px;bottom: 0px;">
        <div class="title">最新事件</div>
        <div class="body">
          <datav-map-event-list ref="eventList" @equip-click="handleEquipClick" @equip-hover="handleEquipHover" />
        </div>
      </div>
    </div>

    <div class="right">
      <div class="panel" style="position: absolute;top: 0px;height: 360px;">
        <div class="title">用户活跃度</div>
        <div class="body">
          <datav-map-visit-stats ref="visitStats" />
        </div>
      </div>

      <div class="panel" style="position: absolute;top: 380px;bottom: 0px;">
        <div class="title">最新访问</div>
        <div class="body">
          <datav-map-visit-list ref="visitList" @equip-click="handleEquipClick" @equip-hover="handleEquipHover" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
    DatavMapMain: () => import('./components/DatavMapMain'),
    DatavMapEquipStats: () => import('./components/DatavMapEquipStats'),
    DatavMapEventList: () => import('./components/DatavMapEventList'),
    DatavMapVisitStats: () => import('./components/DatavMapVisitStats'),
    DatavMapVisitList: () => import('./components/DatavMapVisitList'),
  },

  data() {
    return {
    }
  },

  computed: {
    isCollapse() {
      return this.$store.state.commonStore.collapse;
    },
  },

  watch: {
  },

  created() {
  },

  beforeDestroy() {
  },

  beforeRouteLeave(to, from, next) {
    this.$refs['mainMap'].stopInterval()
    next();
  },
  
  methods: {
    handleEquipClick(equipid) {
      this.$detail({type:'equip',id:equipid});
    },

    handleEquipHover(equipid) {
      this.$refs['mainMap'].highLightEquip(equipid)
    },

    handleEquipTotalChange(oldVal, newVal) {
      this.$refs['mainMap'].fetchStaticData()
    }
  }
}
</script>

<style lang="scss">
.datav-map {
  position: fixed;
  top: 0px;
  height: 100vh;
  margin: 0px -20px;
  color: #f3f3f3;
  background-color: rgb(11, 18, 37);
  >.main {
    width: 100%;
    height: 100%;
  }
  >.top {
    position:absolute;
    left: 420px;
    right: 420px;
    top: 20px;
    height: auto;
  }
  >.left {
    position: absolute;
    left: 20px;
    width: 400px;
    top: 80px;
    bottom: 20px;
  }
  >.right {
    position: absolute;
    right: 20px;
    width: 400px;
    top: 80px;
    bottom: 20px;
  }
  .panel {
    border-top:2px transparent solid;
    border-image: -webkit-linear-gradient(left, #202632, #b2e6f3, #202632) 30 30;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.15);
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    .title {
      flex: none;
      text-align: center;
      font-size: 1.2em;
      font-weight: bold;
      letter-spacing: 2px;
    }
    .body {
      flex: auto;
      overflow: hidden;
    }
  }
}
</style>
